import { Controller } from "@hotwired/stimulus"

// Phase 3.1 Tier 3 — admin: provider listing edit form.
//
// Wires the repeatable "setup steps" inputs and the kind-specific
// OAuth-scope rows. Both swap server-side hashes for typed inputs so
// admins never touch raw JSON.
export default class extends Controller {
  static targets = ["stepList", "stepRow", "scopeList", "scopeRow"]

  addStep() {
    const idx = this.stepRowTargets.length + 1
    const row = document.createElement("div")
    row.className = "flex items-center gap-2"
    row.dataset.integrationAdminProviderFormTarget = "stepRow"
    row.innerHTML = `
      <span class="text-[12px] text-gray-400 w-6 text-right">${idx}.</span>
      <input type="text" name="integration_provider[setup_steps][]"
             class="flex-1 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
      <button type="button" data-action="click->integration-admin-provider-form#removeStep"
              class="p-1.5 text-gray-400 hover:text-rose-600 hover:bg-rose-50 rounded-md cursor-pointer">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.74 9 14.394 18m-4.788 0L9.26 9m9.968-3.21a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/></svg>
      </button>
    `
    this.stepListTarget.appendChild(row)
  }

  removeStep(event) {
    const row = event.currentTarget.closest("[data-integration-admin-provider-form-target=\"stepRow\"]")
    if (row) row.remove()
    this._renumberSteps()
  }

  _renumberSteps() {
    this.stepRowTargets.forEach((row, idx) => {
      const label = row.querySelector("span")
      if (label) label.textContent = `${idx + 1}.`
    })
  }

  addScope() {
    const row = document.createElement("div")
    row.className = "grid grid-cols-1 md:grid-cols-12 gap-2 items-start"
    row.dataset.integrationAdminProviderFormTarget = "scopeRow"
    row.innerHTML = `
      <input type="text" name="integration_provider[default_oauth_scopes][][slug]" placeholder="scope.slug"
             class="md:col-span-3 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white font-mono focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
      <input type="text" name="integration_provider[default_oauth_scopes][][label]" placeholder="Label shown to admins"
             class="md:col-span-4 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
      <input type="text" name="integration_provider[default_oauth_scopes][][feature]" placeholder="Required for (feature key)"
             class="md:col-span-3 px-3 py-2 text-sm border border-gray-200 rounded-lg bg-white font-mono focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand">
      <label class="md:col-span-1 flex items-center gap-1 text-[12px] text-gray-700 px-2 py-2">
        <input type="hidden" name="integration_provider[default_oauth_scopes][][required]" value="false">
        <input type="checkbox" name="integration_provider[default_oauth_scopes][][required]" value="true">
        Req
      </label>
      <button type="button" data-action="click->integration-admin-provider-form#removeScope"
              class="md:col-span-1 p-1.5 text-gray-400 hover:text-rose-600 hover:bg-rose-50 rounded-md cursor-pointer self-center">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M14.74 9 14.394 18m-4.788 0L9.26 9m9.968-3.21a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"/></svg>
      </button>
    `
    this.scopeListTarget.appendChild(row)
  }

  removeScope(event) {
    const row = event.currentTarget.closest("[data-integration-admin-provider-form-target=\"scopeRow\"]")
    if (row) row.remove()
  }
}
